import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !***FX-TRANSACTION SALES  API CONFIG                                                       ***!
  \*******************************************************************************/
export const apiConfig = {
  // Sales Transaction
  salesTransaction: BOM.baseUrl("fxtransactions"),
  newSalesTransaction: BOM.baseUrl("fxtransactions/sell"),
  GetCurrencies: BOM.baseUrl("currencies"),
  GetLocalCurrencies: BOM.baseUrl("fxtransactions/localcurrency"),
  GetByAccountNo: BOM.baseUrl("savingsaccounts/findbyaccountno"),
  GetSavingsAccountByNo: BOM.baseUrl("savingsaccounts/account"),
  GetFxCharges: BOM.baseUrl("savingsproducts"),
  convertAmount: BOM.baseUrl("fxtransactions"),
  Transactions: BOM.baseUrl("transactions"),
  savingsAccounts: BOM.baseUrl("savingsaccounts"),
  savingsAccountsTeller: BOM.baseUrl("savingsaccounts", "teller"),
  savingsAccountsTransactions: BOM.baseUrl(
    "savingsaccountstransactions",
    "teller",
  ),
  Tellerconfig: BOM.baseUrl("tellerconfig", "teller"),
  Customizedteller: BOM.baseUrl("customizedteller", "teller"),
  BranchBatch: BOM.baseUrl("branchbatchmast", "teller"),
  TellerBatch: BOM.baseUrl("tellerbatchmast", "teller"),
  VaultBatch: BOM.baseUrl("vaultbatchmast", "teller"),
  PaymentTypes: BOM.baseUrl("paymenttypes", "teller"),
  Transaction: BOM.baseUrl("tellertransaction", "teller"),
  TransferFund: BOM.baseUrl("accounttransfers", "teller"),
  Cheques: BOM.baseUrl("cheques", "teller"),
  Clients: BOM.baseUrl("clients"),
  Currencies: BOM.baseUrl("currencies"),
};

/*!*******************************************************************************!
  !*** FX-TRANSACTION SALES  LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  // CASH DEPOSIT
  manageCashDeposit: "Manage Cash Deposit",
  newCashDeposit: "New Cash Deposit",
  cashDeposit: "Cash Deposit",
  detailCashDeposit: "Cash Deposit Detail",
  transactionDate: "Transaction Date",
  amountACY: "Amount ACY",
  accountNo: "Account No",
  chequeNo: "Cheque No",
  transactionType: "Transaction Type",
  transactionAmount: "Transaction Amount",
  paymentType: "Payment Type",
  accountName: "Account Name",
  bankNumber: "Bank Number",
  accountCurrency: "Account Currency",
  transactionCCY: "Transaction CCY",
  amountLCY: "Amount LCY",
  amountTCY: "Amount TCY",
  charge: "Charge",
  currencyRate: "Currency Rate",
  chargeId: "Charge Id",
  currency: "Currency",
  depositSetup: "Deposit Setup",
  newSalesTransactionMsg: "FX Sales Transaction was successfully created",
  editSalesTransactionMsg: "FX Sales Transaction was successfully edited",
  generalInfo: "General Information",
  accountNumber: "Account Number",
  chequeNumber: "Cheque Number",
  receiptNumber: "Receipt Number",
  routingCode: "Routing Code",
  bank: "Bank",
  note: "Note",

  //   CHEQUE DEPOSIT
  manageChequeDeposit: "Manage Cheque Deposit",
  newChequeDeposit: "New Cheque Deposit",
  detailChequeDeposit: "Cheque Deposit Detail",

  //   CASH WITHDRAWAL
  manageCashWithdrawal: "Manage Cash Withdrawal",
  newCashWithdrawal: "New Cash Withdrawal",
  cashWithdrawal: "Cash Withdrawal",
  detailCashWithdrawal: "Cash Withdrawal Detail",
  withdrawalSetup: "Withdrawal Setup",

  //   CHEQUE WITHDRAWAL
  manageChequeWithdrawal: "Manage Cheque Withdrawal",
  newChequeWithdrawal: "New Cheque Withdrawal",
  detailChequeWithdrawal: "Cheque Withdrawal Detail",

  // Link User To Till
  manageLinkUserToTill: "Teller Configurations ",
  newLinkUserToTill: "New Cheque Withdrawal",
  detailLinkUserToTill: "Test Head Teller",
  viewLinkUserToTill: "Teller Configurations Detail",
  manageLinkUserToTillTeller: "Teller",
  tellerConfigDetail: "Teller Detail",
  newTeller: "New Teller",
  detailTeller: "Teller Detail",
  editTeller: "Edit Teller",

  // Branch Batch
  branchBatch: "Branch Batch Management",
  manageBranchBatch: "Manage Branch Batch",

  // Vault Batch
  vaultBatch: "Vault Batch Management",
  manageVaultBatch: "Manage Vault Batch",

  // Funds Transfer
  fundsTransfer: "Funds Transfer",
  manageFundsTransfer: "Manage Funds Transfer",

  // Teller Batch
  tellerBatch: "Teller Batch Management",
  manageTellerBatch: "Manage Teller Batch",

  // Teller Transactions
  manageTellerTransactions: "Manage Teller Transactions",
  receiveTellerTransaction: "Receive Teller Transaction",
  tellerTransactionDetail: "Teller Transaction Detail",
  viewTellerTransactionDetail: "View Teller Transaction",
};

/*!*******************************************************************************!
    !*** FX-TRANSACTION PURCHASE STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  // CASH DEPOSIT ITEMS
  manageCashDepositItems: [{ title: labelConfig.manageCashDeposit }],
  detailCashDepositItems: [
    {
      title: <Link to="/tlo0800">{labelConfig.manageCashDeposit}</Link>,
    },
    { title: labelConfig.detailCashDeposit },
  ],
  newCashDepositItems: [{ title: labelConfig.newCashDeposit }],
  cashDepositItems: [{ title: labelConfig.cashDeposit }],

  // CASH WITHDRAWAL ITEMS
  manageCashWithdrawalItems: [{ title: labelConfig.manageCashWithdrawal }],
  detailCashWithdrawalItems: [
    {
      title: <Link to="/tlo0900">{labelConfig.manageCashWithdrawal}</Link>,
    },
    { title: labelConfig.detailCashWithdrawal },
  ],
  newCashWithdrawalItems: [
    {
      title: <Link to="/tlo0900">{labelConfig.manageCashWithdrawal}</Link>,
    },
    { title: labelConfig.newCashWithdrawal },
  ],
  cashWithdrawalItems: [{ title: labelConfig.cashWithdrawal }],

  // CHEQUE DEPOSIT ITEMS

  manageChequeDepositItems: [{ title: labelConfig.manageChequeDeposit }],
  detailChequeDepositItems: [
    {
      title: <Link to="/tlo1000">{labelConfig.manageChequeDeposit}</Link>,
    },
    { title: labelConfig.detailChequeDeposit },
  ],
  newChequeDepositItems: [
    // {
    //   title: <Link to="/tlo1000">{labelConfig.manageChequeDeposit}</Link>,
    // },
    { title: labelConfig.newChequeDeposit },
  ],
  monthList: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  transactionTypeData: [
    { label: "Purchase", value: "1" },
    { label: "Sale", value: "2" },
  ],

  // CHEQUE WITHDRAWAL ITEMS

  manageChequeWithdrawalItems: [{ title: labelConfig.manageChequeWithdrawal }],
  detailChequeWithdrawalItems: [
    {
      title: <Link to="/tlo1100">{labelConfig.manageChequeWithdrawal}</Link>,
    },
    { title: labelConfig.detailChequeWithdrawal },
  ],
  newChequeWithdrawalItems: [
    {
      title: <Link to="/tlo1100">{labelConfig.manageChequeWithdrawal}</Link>,
    },
    { title: labelConfig.newChequeWithdrawal },
  ],
  monthList: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  transactionTypeData: [
    { label: "Purchase", value: "1" },
    { label: "Sale", value: "2" },
  ],

  // Link User to till
  manageLinkUserToTillItems: [{ title: labelConfig.manageLinkUserToTill }],
  manageLinkUserToTillTellerItems: [
    {
      title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link>,
    },
    { title: labelConfig.manageLinkUserToTillTeller },
  ],
  tellerConfigDetailBreadcrumbItems: [
    { title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link> },
    // { title: labelConfig.tellerConfigDetail },
  ],
  newTellerBreadcrumbItems: [
    {
      title: (
        <Link to="/detail-tlo0100">
          {labelConfig.manageLinkUserToTillTeller}
        </Link>
      ),
    },
    { title: labelConfig.newTeller },
  ],
  detailTellerBreadcrumbItems: [
    { title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link> },
    {
      title: (
        <Link to="/detail-tlo0100">
          {labelConfig.manageLinkUserToTillTeller}
        </Link>
      ),
    },
    { title: labelConfig.detailTeller },
  ],
  editTellerBreadcrumbItems: [
    { title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link> },
    {
      title: (
        <Link to="/detail-tlo0100">
          {labelConfig.manageLinkUserToTillTeller}
        </Link>
      ),
    },
    { title: labelConfig.editTeller },
  ],

  // Branch Batch
  branchBatchItems: [{ title: labelConfig.branchBatch }],

  // Vault Batch
  vaultBatchItems: [{ title: labelConfig.vaultBatch }],

  // Funds Transfer
  fundsTransferItems: [{ title: labelConfig.fundsTransfer }],

  // Teller Batch
  tellerBatchItems: [{ title: labelConfig.tellerBatch }],

  // Teller Transactions
  manageTellerTransactionsItems: [
    { title: labelConfig.manageTellerTransactions },
  ],
  tellerTransactionDetailItems: [
    {
      title: <Link to="/tlo0700">{labelConfig.manageTellerTransactions}</Link>,
    },
    { title: labelConfig.viewTellerTransactionDetail },
  ],
};
